<template>
  <div>
    <VSelect
      v-model="data.glycolType"
      :label="$t('forms.labels.type')"
      :items="displayedGlycol"
      required
      itemValue="key"
      itemText="name"
      :loading="typeLoading"
      outlined
      data-cy="selectGlycol"
    />
    <VTextField
      v-if="data.glycolType === 'other'"
      v-model="data.glycolOther"
      outlined
      :label="$t('forms.labels.moreInfo')"
      :rules="{ min: 1, max: 200 }"
    />
    <p class="titleModal">
      {{ $t('forms.labels.treatment') }}
    </p>
    <VTextField
      v-model="data.treatment"
      outlined
      :label="$t('forms.labels.treatment')"
      data-cy="cyArTreatment"
      :rules="{ required: true, min: 1, max: 200 }"
    />
    <VTextField
      v-model="data.otherTreatment"
      :label="$t('forms.labels.otherTreatment')"
      :rules="{ max: 1000 }"
      outlined
      data-cy="cyArOtherTreatment"
    />
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VTextField,
    },
    props: {
        analysisRequest: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data: {
                treatment: this.analysisRequest.treatment,
                otherTreatment: this.analysisRequest.otherTreatment,
                glycolType: this.analysisRequest.glycolType,
                glycolOther: this.analysisRequest.glycolOther,
            },
            typeLoading: false,
            types: [],
        };
    },
    computed: {
        displayedGlycol() {
            return this.types.map(key => ({
                key,
                name: this.$t(`glycolTypes.${key}`),
            }));
        },
    },
    watch: {
        data: {
            handler() {
                this.$emit('updateData', this.data);
            },
            deep: true,
        },
    },
    async created() {
        await this.loadData();
    },
    methods: {
        async loadData() {
            this.typeLoading = true;
            const { data } = await this.$rq.getGlycolTypes();
            this.types = data.types;
            this.typeLoading = false;
        },
    },
};
</script>
